/* ==========================================================================
   Epic Trace — comportements globaux
   Navigation, tiroir panier, accordeons, apparitions au defilement.
   ========================================================================== */
(function () {
  'use strict';

  var SELECTORS = {
    header: '[data-header]',
    burger: '[data-menu-open]',
    mobileNav: '[data-mobile-nav]',
    menuClose: '[data-menu-close]',
    cartDrawer: '[data-cart-drawer]',
    cartOpen: '[data-cart-open]',
    cartClose: '[data-cart-close]',
    cartInner: '[data-cart-inner]',
    cartFoot: '[data-cart-foot]',
    cartCount: '[data-cart-count]'
  };

  var focusReturn = null;

  /* --- Utilitaires -------------------------------------------------------- */

  function money(cents) {
    var format = (window.EpicTrace && window.EpicTrace.moneyFormat) || '{{amount_with_comma_separator}} €';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var integer = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

    if (format.indexOf('amount_no_decimals') !== -1) {
      return format.replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100).toString());
    }
    if (format.indexOf('amount_with_comma_separator') !== -1) {
      return format.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, integer + ',' + parts[1]);
    }
    return format.replace(/\{\{\s*amount\s*\}\}/, integer + '.' + parts[1]);
  }

  function trapFocus(container) {
    var focusables = container.querySelectorAll(
      'a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    if (!focusables.length) return;
    var first = focusables[0];
    var last = focusables[focusables.length - 1];

    function onKeydown(event) {
      if (event.key !== 'Tab') return;
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    container.addEventListener('keydown', onKeydown);
    container.__releaseFocus = function () {
      container.removeEventListener('keydown', onKeydown);
    };
    first.focus();
  }

  function releaseFocus(container) {
    if (container && container.__releaseFocus) {
      container.__releaseFocus();
      delete container.__releaseFocus;
    }
  }

  function lockScroll(locked) {
    document.body.classList.toggle('overflow-hidden', locked);
  }

  /* --- En-tete collant ---------------------------------------------------- */

  function initStickyHeader() {
    var header = document.querySelector(SELECTORS.header);
    if (!header) return;

    var update = function () {
      header.classList.toggle('is-stuck', window.scrollY > 8);
    };

    update();
    window.addEventListener('scroll', update, { passive: true });
  }

  /* --- Menu mobile -------------------------------------------------------- */

  function initMobileNav() {
    var nav = document.querySelector(SELECTORS.mobileNav);
    if (!nav) return;

    function open() {
      focusReturn = document.activeElement;
      nav.classList.add('is-open');
      nav.setAttribute('aria-hidden', 'false');
      lockScroll(true);
      trapFocus(nav);
    }

    function close() {
      nav.classList.remove('is-open');
      nav.setAttribute('aria-hidden', 'true');
      lockScroll(false);
      releaseFocus(nav);
      if (focusReturn && focusReturn.focus) focusReturn.focus();
    }

    document.querySelectorAll(SELECTORS.burger).forEach(function (button) {
      button.addEventListener('click', open);
    });
    document.querySelectorAll(SELECTORS.menuClose).forEach(function (button) {
      button.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && nav.classList.contains('is-open')) close();
    });

    nav.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', close);
    });
  }

  /* --- Tiroir panier ------------------------------------------------------ */

  var CartDrawer = {
    el: null,

    init: function () {
      this.el = document.querySelector(SELECTORS.cartDrawer);

      document.addEventListener('click', function (event) {
        var openBtn = event.target.closest(SELECTORS.cartOpen);
        if (openBtn) {
          // Sans JS actif on laisse le lien vers /cart faire son travail.
          event.preventDefault();
          CartDrawer.open();
          return;
        }
        if (event.target.closest(SELECTORS.cartClose)) {
          event.preventDefault();
          CartDrawer.close();
        }
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') CartDrawer.close();
      });

      this.bindLineActions();
    },

    open: function () {
      if (!this.el) return;
      focusReturn = document.activeElement;
      this.el.classList.add('is-open');
      this.el.setAttribute('aria-hidden', 'false');
      lockScroll(true);
      trapFocus(this.el);
    },

    close: function () {
      if (!this.el || !this.el.classList.contains('is-open')) return;
      this.el.classList.remove('is-open');
      this.el.setAttribute('aria-hidden', 'true');
      lockScroll(false);
      releaseFocus(this.el);
      if (focusReturn && focusReturn.focus) focusReturn.focus();
    },

    /* Quantites et suppression, dans le tiroir comme sur la page panier */
    bindLineActions: function () {
      document.addEventListener('click', function (event) {
        var step = event.target.closest('[data-qty-step]');
        if (step) {
          event.preventDefault();
          var input = step.parentElement.querySelector('input[data-qty-input]');
          if (!input) return;
          var delta = step.getAttribute('data-qty-step') === 'up' ? 1 : -1;
          var next = Math.max(0, (parseInt(input.value, 10) || 0) + delta);
          input.value = next;
          CartDrawer.updateLine(input.getAttribute('data-line'), next, step);
          return;
        }

        var remove = event.target.closest('[data-cart-remove]');
        if (remove) {
          event.preventDefault();
          CartDrawer.updateLine(remove.getAttribute('data-line'), 0, remove);
        }
      });

      document.addEventListener('change', function (event) {
        var input = event.target.closest('input[data-qty-input]');
        if (!input) return;
        var value = Math.max(0, parseInt(input.value, 10) || 0);
        input.value = value;
        CartDrawer.updateLine(input.getAttribute('data-line'), value, input);
      });
    },

    updateLine: function (line, quantity, origin) {
      if (!line) return;
      var scope = origin && origin.closest('[data-cart-inner], [data-cart-page]');
      if (scope) scope.classList.add('is-loading');

      fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          line: line,
          quantity: quantity,
          sections: 'cart-drawer',
          sections_url: window.location.pathname
        })
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          CartDrawer.render(cart);
          if (document.querySelector('[data-cart-page]')) window.location.reload();
        })
        .catch(function () {
          window.location.reload();
        })
        .finally(function () {
          if (scope) scope.classList.remove('is-loading');
        });
    },

    render: function (cart) {
      if (cart && cart.sections && cart.sections['cart-drawer']) {
        var parsed = new DOMParser().parseFromString(cart.sections['cart-drawer'], 'text/html');
        var fresh = parsed.querySelector(SELECTORS.cartInner);
        var current = document.querySelector(SELECTORS.cartInner);
        if (fresh && current) current.innerHTML = fresh.innerHTML;

        /* Le pied (sous-total, bouton Commander) vit hors du corps et Liquid ne
           le rend que si le panier a des lignes au chargement de la page. Ne
           rafraichir que le corps laissait donc un tiroir SANS bouton de
           paiement apres un ajout depuis une page chargee panier vide, et un
           pied fantome apres avoir tout retire. On l'aligne sur la section
           fraiche : remplace, ajoute ou retire. */
        var freshFoot = parsed.querySelector(SELECTORS.cartFoot);
        var currentFoot = document.querySelector(SELECTORS.cartFoot);
        if (freshFoot) {
          var imported = document.importNode(freshFoot, true);
          if (currentFoot) currentFoot.replaceWith(imported);
          else if (current) current.insertAdjacentElement('afterend', imported);
        } else if (currentFoot) {
          currentFoot.remove();
        }
      }
      this.updateCount(cart ? cart.item_count : 0);
    },

    updateCount: function (count) {
      document.querySelectorAll(SELECTORS.cartCount).forEach(function (node) {
        node.textContent = count;
        node.hidden = count === 0;
      });
    },

    /* Utilise par product-form.js */
    addFromForm: function (form, button) {
      var data = new FormData(form);
      data.append('sections', 'cart-drawer');
      data.append('sections_url', window.location.pathname);

      var label = button ? button.innerHTML : '';
      if (button) {
        button.setAttribute('aria-disabled', 'true');
        button.innerHTML = '<span class="spinner" aria-hidden="true"></span>';
      }

      return fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: data
      })
        .then(function (response) {
          return response.json().then(function (body) {
            if (!response.ok) throw body;
            return body;
          });
        })
        .then(function (cart) {
          CartDrawer.render(cart);
          CartDrawer.open();
          return cart;
        })
        .finally(function () {
          if (button) {
            button.removeAttribute('aria-disabled');
            button.innerHTML = label;
          }
        });
    }
  };

  /* --- Accordeons exclusifs ---------------------------------------------- */

  function initAccordions() {
    document.querySelectorAll('[data-accordion-exclusive]').forEach(function (group) {
      var items = group.querySelectorAll('details');
      items.forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (!item.open) return;
          items.forEach(function (other) {
            if (other !== item) other.open = false;
          });
        });
      });
    });
  }

  /* --- Apparition au defilement ------------------------------------------ */

  function initReveal() {
    var targets = document.querySelectorAll('.reveal');
    if (!targets.length) return;

    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (node) {
        node.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
    );

    targets.forEach(function (node) {
      observer.observe(node);
    });
  }

  /* --- Galerie produit --------------------------------------------------- */

  function initGallery() {
    document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
      var main = gallery.querySelector('[data-gallery-main]');
      gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          if (!main) return;
          main.innerHTML = thumb.getAttribute('data-media');
          gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (other) {
            other.setAttribute('aria-current', other === thumb ? 'true' : 'false');
          });
        });
      });

      /* « Voir plus » : revele les vignettes masquees cote Liquid (attribut hidden)
         et donne le focus a la premiere d'entre elles pour le clavier. */
      var more = gallery.querySelector('[data-gallery-more]');
      if (more) {
        more.addEventListener('click', function () {
          var hiddenThumbs = gallery.querySelectorAll('[data-gallery-thumb][hidden]');
          hiddenThumbs.forEach(function (thumb) {
            thumb.removeAttribute('hidden');
          });
          more.remove();
          if (hiddenThumbs[0]) hiddenThumbs[0].focus();
        });
      }
    });
  }

  /* --- Init -------------------------------------------------------------- */

  function init() {
    window.Shopify = window.Shopify || {};
    window.Shopify.routes = window.Shopify.routes || { root: '/' };

    initStickyHeader();
    initMobileNav();
    CartDrawer.init();
    initAccordions();
    initReveal();
    initGallery();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.EpicTrace = window.EpicTrace || {};
  window.EpicTrace.CartDrawer = CartDrawer;
  window.EpicTrace.money = money;
})();
